import { render } from "./GoogleLoginCallbackView.vue?vue&type=template&id=e52ab1c6&scoped=true"
import script from "./GoogleLoginCallbackView.vue?vue&type=script&lang=js"
export * from "./GoogleLoginCallbackView.vue?vue&type=script&lang=js"

import "./GoogleLoginCallbackView.vue?vue&type=style&index=0&id=e52ab1c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52ab1c6"]])

export default __exports__